<script>
    import {onMount} from 'svelte'
    let animate = null
    let animate2 =null
    let main =false
    const wait = time => new Promise(resolve=>setTimeout(resolve,time))
    const prev = async ()=>{
        if(animate || animate2) return
        const end = {...sortedData[0]}
        sortedData = [...sortedData,end]
        document.querySelector(".slide-wrapper").classList.add("animate2")
        animate2 = true
        await wait(1000)
        animate2 = false
        document.querySelector(".slide-wrapper").classList.remove("animate2")
        
        sortedData = [...sortedData.slice(1)]
    }
    const next =async()=>{
        if(animate || animate2) return
        const end = {...sortedData[sortedData.length - 1]}
        sortedData = [end,...sortedData]
        document.querySelector(".slide-wrapper").classList.add("animate")
        animate = true
        await wait(1000)
        animate = false
        document.querySelector(".slide-wrapper").classList.remove("animate")
        
        sortedData = [...sortedData.slice(0,-1)]
    }
    export let data
    
    $: sortedData = data
    onMount(()=>{
        const end = {...sortedData[sortedData.length - 1]}
        sortedData.pop()
        sortedData = [end,...sortedData]
    })
    const getMainIndex = index => {
        if(animate2){
            if(index == 2) return true
        }else{
            if(index === 1) return true
            else return false
        }
    }
</script>
<div class="wrapper">
    <div class="slide-wrapper">
        {#each sortedData as item,index (item)}
        <div class="slide" class:main={getMainIndex(index)} class:animate class:animate2>
            <div><h3>{item.num}</h3><h2>{item.title}</h2></div>
            <img src={item.img} alt="">
            <p>{item.text}</p>
        </div>
        {/each}
    </div>
    <div class="btn">
        <a on:click={next}> 
            <span class="pc">
            <img src="img/prev.svg" alt="">
            前の項目
            </span>
            <span class="mb">
                <img src="img/prev_mb.svg" alt="">
            </span>
        </a>
        <a on:click={prev}> 
            <span  class="pc">
                <img src="img/next.svg" alt="">
                次の項目
            </span>
            <span class="mb">
                <img src="img/next_mb.svg" alt="">
            </span>
        </a>
    </div>
</div>

<style>
    @keyframes slidein{
        0%{
            transform: translateX(-126px);
        }
        100%{
            transform: translateX(0px);
        }
    }
    @keyframes slideout{
        0%{
            transform: translateX(0px);
        }
        100%{
            transform: translateX(-123px);
        }
    }
    .wrapper{
        width: 100%;
        margin: auto;
        
        overflow: hidden;
    }
    .slide-wrapper{
        display: flex;
        width: 100%;
        transform: translateX(0);
        height:720px;
    }
    .slide{
        width:246px;
        height:296px;
        display:flex;
        flex-direction: column;
        opacity:0.3;
        flex-shrink: 0;
        transition: all 1s;
        margin-left: 60px;
        margin-top: 48px;
        transition:all 1s;
    }
    .slide div{
        display: flex;
        align-items: center;
        height: 58px;
    }
    .slide h3{
        
        font-size: 30px;
        line-height: 31px;
        margin: 0;
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        text-align: left;
        color: #ff9b11;
    }
    .slide.main h3{
        font-size: 40px;
        line-height: 41px;
    }
    .slide h2{
        margin: 0;
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        margin-left: 10px;
        font-size: 16px;
        line-height: 31px;
        text-align: left;
        color: #000;
    }
    .slide.main h2{
        font-size: 24px;
        line-height: 41px;
    }

    .slide img{
        margin-top: 22px;
    }
    .slide p{
        opacity: 0;
        font-family: "Noto Sans JP",sans-serif;
        
        font-size: 16px;
        line-height: 36px;
        text-align: left;
        color: #000;
    }
    .slide.main p{
        opacity:1;
        transition:all .5s;
        transition-delay: 1s;
    }
    .slide {
        font-family: "Noto Sans JP",sans-serif;
        
        font-size: 16px;
        line-height: 36px;
        text-align: left;
        color: #000;
    }
    .slide:nth-child(1){
        margin-left: 0;
    }
    .main{
        margin-top: 0;
        opacity:1;
        transition: all 1s;
        flex-shrink: 0;
        width:495px;
        height:auto;
    }
    .animate{
        animation-duration: 1s;
        animation-name: slidein;
        animation-fill-mode:both;
    }
    .animate2{
        animation-duration: 1s;
        animation-name: slideout;
        animation-fill-mode:both;
    }
    .animate2:nth-child(2){
        margin-left:0px!important;
    }
    .btn a{
        font-family: "Noto Sans JP",sans-serif;
        
        font-size: 16px;
        line-height: 36px;
        text-align: left;
        color: #000;
        text-decoration: none;
        display: flex;
        width: 64px;
        height:24px;
        flex-direction: column;
        align-items: center;
    }
    .pc{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .btn{
        display: flex;
        width: 719px;
        margin: auto;
        margin-top: -260px;
        left: 190px;
        position: absolute;
        justify-content: space-between;
    }
    .mb{
        display: none;
    }
    @media screen and (max-width:640px){
        .pc{
            display: none;
        }
        .mb{display: flex;}
        .btn{
            margin-top: 0;
            top:180px;
            width: 120%;
            left:-10%;
            z-index:100;
            position: absolute;
            z-index: 10;
        }
        .slide{
            opacity:0;
            margin: 0px;
            width: 100%;
        }
        .wrapper{
            position: relative;
            overflow: initial;
            z-index: 10;
        }
        .slide div{

            height: 41px;
        }
        .slide.main{
            width: 100%;
            height:auto;
            opacity:1;
        }
        .slide-wrapper{
            width:111%;
            position: relative;
            z-index: 10;
            width: 100%;
            left:-5.5%;
            transform: translateX(-95%);
        }
        .slide h3{
            opacity:0;
            transition:all .5s;
        }
        .main.slide h3{
            opacity:1;
            transition:all .5s;
        }
        .slide p{
            width: 90%;
            margin: auto;
        }
        .slide img{
            object-fit: cover;
            width:70%;
            position: relative;
            transition:all .5s;
        }
        .main{
            width: 100%;
        }
        .slide p{
            margin-top: 20px;
        }
        .main img{
            width: 100%;
            object-fit: cover;
            height:294px;
            transition:all .5s;
        }
        .animate2:nth-child(2){
            margin-left:0px!important;
        }
        .mb img{
            width: 40px;
            height: 40px;
        }
        @keyframes slidein{
            0%{
                transform: translateX(-95%);
            }
            100%{
                transform: translateX(-47.5%);
            }
        }
        @keyframes slideout{
            0%{
                transform: translateX(-53.5%);
            }
            100%{
                transform: translateX(-97.5%);
            }
        }
    }
</style>